import React from "react";
import CellDetails from "../CellDetails/CellDetails";

const ViewDetails = ({ data, columns }) => {
  const styles = {
    columnCount: columns,
    columnGap: "30%", // sets the size of the gap between columns
    display: "grid",
    gridTemplateColumns: `repeat(${columns}, 1fr)`,
    gap: "0.9rem",
    padding: "4em",
    paddingTop: "2em",
    paddingBottom:"0em"
  };
  return (
    <div style={styles}>
      {data?.map((item) => (
        <CellDetails item={item} />
      ))}
    </div>
  );
};

export default ViewDetails;
